import {
  MailSvg,
  PersonSvg,
} from "../../../shop-layouts/checkout-page-layout/CheckoutComponent/shared/form/FormSvgIcons";
import { ReactComponent as MessageSvg } from "./detail-konfi.svg";

export const formDefinition: (
  firstNamePlaceholder: string,
  lastNamePlaceholder: string,
  messagePlaceholder: string,
) => Array<FormDefinition> = (firstNamePlaceholder, lastNamePlaceholder, messagePlaceholder) => [
  {
    Icon: PersonSvg,
    iconAlignment: "center" as const,
    placeholder: firstNamePlaceholder,
    id: formIds.firstName,
    type: "text",
    height: 70,
  },
  {
    Icon: PersonSvg,
    iconAlignment: "center" as const,
    placeholder: lastNamePlaceholder,
    id: formIds.lastName,
    type: "text",
    height: 70,
  },
  {
    Icon: MessageSvg,
    iconAlignment: "top" as const,
    placeholder: messagePlaceholder,
    id: formIds.message,
    type: "long-text",
    height: 250,
    charactersLimit: 250,
  },
];

export type FormDefinitionText = {
  id: string;
  type: "text";
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  iconAlignment: "center" | "top";
  placeholder: string;
  height: number;
};

export type FormDefinitionLongText = {
  id: string;
  type: "long-text";
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  iconAlignment: "center" | "top";
  placeholder: string;
  height: number;
  charactersLimit: number;
};

export type FormDefinition = FormDefinitionText | FormDefinitionLongText;
export const emailFormFieldDefinition: (emailPlaceholder: string) => FormDefinitionText = emailPlaceholder => ({
  height: 70,
  type: "text",
  placeholder: emailPlaceholder,
  id: formIds.email,
  Icon: MailSvg,
  iconAlignment: "center",
});

export const formIds = {
  email: "pdp-form-gift-card-email",
  firstName: "pdp-form-gift-card-firstName",
  lastName: "pdp-form-gift-card-lastName",
  message: "pdp-form-gift-card-message",
};
